import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMail2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={43} height={43} fill="#B4B4B4" rx={3} />
      <path
        fill="#FFF"
        d="M28.5 14.5h-14c-.962 0-1.741.787-1.741 1.75l-.009 10.5c0 .962.788 1.75 1.75 1.75h14c.962 0 1.75-.788 1.75-1.75v-10.5c0-.963-.788-1.75-1.75-1.75zm0 3.5-7 4.375-7-4.375v-1.75l7 4.375 7-4.375V18z"
      />
      <path d="M11 11h21v21H11z" />
    </g>
  </svg>
);
export default SvgMail2;
